<template>
    <div class="sticky-top">
        <div id="scrollable">
            <div v-for="menu in content" :key="menu.id">
                <recursive-menu
                    :ref="`recursive-menu-${menu.id}`"
                    class="pl-3"
                    :menu="menu"
                    @title-clicked="titleClicked"
                />
            </div>
        </div>
    </div>
</template>
<script>
import RecursiveMenu from "@/components/soap/soap-recursive-menu.vue";

export default {
    props: {
        content: { type: [Array, Object] }
    },
    components: {
        RecursiveMenu
    },
    methods: {
        titleClicked(elementId) {
            if (elementId) {
                this.$emit("scroll-to-section", elementId);
            }
        }
    }
};
</script>
<style scoped>
.sticky-top {
    position: sticky;
    top: 120px;
    z-index: 9;
}

@media (min-width: 769px) {
    #scrollable {
        max-height: calc(100vh - 30px);
        overflow-y: auto;
        padding-top: 10px;
        padding-bottom: 20px;
        -ms-overflow-style: none; /* Hide scrollbar Internet Explorer & Edge */
        scrollbar-width: none; /* Hide scrollbar Firefox */
    }

    #scrollable::-webkit-scrollbar {
        display: none; /*Hide scrollbar Chrome, Safari and Opera*/
    }
}
</style>
